export default "__VITE_PUBLIC_ASSET__d5a65773__"